import logo from "../assets/icons/logo.png";
import { AppConstant } from "../constant/AppConstant";
import "../assets/css/Maintenance.css";

const Maintenance = () => {
  return (
    <div className="maintenance-root">
  
      <div className="aurora-layer"></div>
      <div className="mesh-layer"></div>

      <span className="floating-shape shape-1"></span>
      <span className="floating-shape shape-2"></span>
      <span className="floating-shape shape-3"></span>

      <div className="maintenance-container">
        <div className="maintenance-card">
 
          <div className="logo-ring">
            <img src={logo} alt="Logo" className="maintenance-logo" />
          </div>

          <h1 className="maintenance-title">We’ll be back shortly</h1>

          <p className="maintenance-subtitle">
            We’re performing scheduled maintenance to improve performance,
            security, and reliability. Thank you for your patience.
          </p>

          <button
            className="primary-btn"
            onClick={() => window.open(`tel:${AppConstant.tollFreeNumber}`)}
          >
            📞 Toll Free: {AppConstant.tollFreeNumber}
          </button>

          <p className="maintenance-footer-text">
            Our support team is available 24/7 for urgent assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
